var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "share-buttons" },
    [
      _vm.facebookText
        ? _c("Button", {
            attrs: {
              level: "primary",
              icon: "facebook",
              small: "",
              type: "button"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.onShare("facebook")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.twitterText
        ? _c("Button", {
            attrs: {
              level: "primary",
              icon: "twitter",
              small: "",
              type: "button"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.onShare("twitter")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.whatsappText
        ? _c("Button", {
            attrs: {
              level: "primary",
              icon: "whatsapp",
              small: "",
              type: "button"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.onShare("whatsapp")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.emailText
        ? _c("Button", {
            attrs: {
              level: "primary",
              icon: "envelope",
              small: "",
              type: "button"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.onShare("email")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }